import { createI18n } from "vue-i18n";

import { en, ru, ua } from "@/shared/locales";

export const LOCALES = ["ru", "ua", "en"] as const;

export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "ru";

/** Коды языков, которые ждёт API it4, там, где они отличаются от наших */
const API_LOCALES: Partial<Record<Locale, string>> = {
    ua: "uk",
};

/** Код языка для запросов к API it4 */
export function toApiLocale(locale: Locale): string {
    return API_LOCALES[locale] ?? locale;
}

export function isLocale(value: unknown): value is Locale {
    return LOCALES.includes(value as Locale);
}

// Factory instead of a singleton: every widget instance on the page gets its own i18n
export function createWidgetI18n(locale: Locale = DEFAULT_LOCALE) {
    return createI18n({
        legacy: false,
        locale,
        fallbackLocale: "en" satisfies Locale,
        messages: { ru, ua, en },
    });
}
